import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import useAuth from 'src/hooks/useAuth';
import { UserTypeEnum } from 'src/utils/enum';

interface GuestProps {
  children: ReactNode;
}

const Guest: FC<GuestProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    return (
      <Navigate
        to={
          user.categoryTypeId === UserTypeEnum.TCA
            ? '/admin/dashboard/home'
            : '/vendor/dashboard/home'
        }
      />
    );
  }

  return <>{children}</>;
};

export default Guest;
